var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSubject(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "256px",
    height: "190px",
    viewBox: "0 0 256 190",
    enableBackground: "new 0 0 256 190",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.12,27.903C48.12,13.564,59.592,2,74.023,2c14.339,0,25.903,11.564,25.903,25.903 C99.834,42.335,88.27,53.806,74.023,53.806C59.684,53.806,48.12,42.242,48.12,27.903z M191,139h-47V97c0-20.461-17.881-37-38-37H43 C20.912,60,1.99,79.14,2,98v77c-0.026,8.533,6.001,12.989,12,13c6.014,0.011,12-4.445,12-13v-75h8v88h78v-88h8l0.081,50.37 c-0.053,8.729,5.342,12.446,10.919,12.63h60C207.363,163,207.363,139,191,139z M168.711,120.755c16.993,0,25.774,2.739,29.553,4.418 H157V72.326h6.627v48.456l4.105-0.027H168.711z M203.22,73.855c0,8.156,0,49.448,0,49.448s-7.626-6.627-34.495-6.627h-1.02 c0-7.817,0-49.788,0-49.788s1.529-0.061,3.949-0.061h0.007C179.981,66.827,198.883,67.541,203.22,73.855z M243.268,120.755 l4.105,0.027V72.326H254v52.847h-41.265c3.779-1.679,12.561-4.418,29.553-4.418H243.268z M239.339,66.827h0.007 c2.42,0,3.949,0.061,3.949,0.061s0,41.971,0,49.788h-1.02c-26.869,0-34.495,6.627-34.495,6.627s0-41.292,0-49.448 C212.117,67.541,231.019,66.827,239.339,66.827z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSubject);
export default __webpack_public_path__ + "static/media/icon-subject.d7fe902d.svg";
export { ForwardRef as ReactComponent };